import React from 'react';
import { LoaderAnimation } from 'src/components';
import { cn } from 'src/utils/cn';

type Props = {
  showLoader?: boolean;
  dark?: boolean;
};

export default function FullPageLoader(props: Props) {
  const containerClass = cn('bg-black-pure-opacity-80 fixed w-full h-full z-[998] top-0 left-0', {
    ['bg-black']: props.dark,
  });

  return (
    <>
      {props?.showLoader && (
        <div className={containerClass}>
          <div className="absolute overflow-y-auto -translate-x-1/2 -translate-y-1/2 bg-black has-text-centered loader-container z-999 top-1/2 left-1/2 rounded-1/2 w-25 h-25 md:w-38 md:h-38 md:overflow-auto">
            <LoaderAnimation height={'100%'} width={'100%'} />
          </div>
        </div>
      )}
    </>
  );
}
